import { hexFromHslColor } from './hexFromHslColor';
export const generateAnalogousColorPalette = (hue, saturation, lightnesses) => lightnesses.map((lightness) => hexFromHslColor({ hue, saturation, lightness }));
